import { chain, orderBy } from 'lodash';
import moment from 'moment';
import * as React from 'react';
import VoxelText from '../../components/voxel/Text/VoxelText';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { QueuedItemStatus } from '../../graphql/projects/models/QueuedItemStatus';

export interface NextCheckInfoProps {
  project: ProjectGq;
}

const NextCheckInfo: React.FC<NextCheckInfoProps> = ({ project }) => {
  // Progress tracking - Completed tracking sessions
  const trackingRequests = orderBy(project?.projectSerpTrackingRequests, (pr) => pr.scheduledTime);
  const completedTrackingRequests = trackingRequests?.filter(
    (tr) => tr.status === QueuedItemStatus.SUCCEEDED
  );
  // Progress tracking - Next data retrieval
  const nextRequest = chain(trackingRequests)
    .filter((tr) => tr.status === QueuedItemStatus.QUEUED)
    .orderBy((tr) => tr.scheduledTime, 'asc')
    .first()
    .value();
  const nextDataRetrieval = nextRequest?.scheduledTime
    ? moment(nextRequest.scheduledTime).utc().format('yyyy-MM-DD')
    : 'TBD';

  return <>{nextDataRetrieval}</>;
};

export default NextCheckInfo;
